var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"event-picture"},[_c('img',{attrs:{"src":_vm.notice_image||_vm.defaultCover,"alt":""}})]),_c('div',{staticClass:"event-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }